import {
  Image,
  FooterContainer,
  LinkText,
  FooterText,
  CenterContainer,
  Divider,
  LogosContainer,
  CertificationsImage,
  CertificationsContainer,
  TextDivider
} from "./styles/FooterStyles";
import { useHistory } from "react-router";
import EscudoPNG from '../../assets/images/EscudoPNG.png'
import MiturPNG from '../../assets/images/MiturWhiteLogo.png'
import A3 from '../../assets/images/A3.png'
import A2 from '../../assets/images/A2.png'
import E1 from '../../assets/images/E1.png'
import { Row, SmallHeightDivider } from '../../theme/Styles'
function Footer() {
  const history = useHistory();
  return (
    <FooterContainer>
      <CenterContainer>
        <LogosContainer>
          {/*           <Image src={EscudoPNG} />
          <Divider /> */}
          <Image src={MiturPNG} />
        </LogosContainer>
        <strong>
          <FooterText>
            Universidad Abierta para Adultos
          </FooterText>
        </strong>
        <FooterText>
          Av. Hispanoamericana #100, Thomén, Código postal No. 51000,Santiago, República Dominicana
        </FooterText>
        <FooterText>
          Tel.: (809) 724-0266 | Fax: (809) 724-0329.
        </FooterText>
        <FooterText>
          info@uapa.edu.do
        </FooterText>
        <Row>
          <LinkText target="_blank" href="https://www.uapa.edu.do/politica-privacidad/">
            Terminos de uso
          </LinkText>
          <TextDivider />
          <LinkText onClick={() => history.push("/app/policy")}>
            Políticas de Privacidad
          </LinkText>
          <TextDivider />
          <LinkText target="_blank" href="https://www.uapa.edu.do/">
            Preguntas Frecuentes
          </LinkText>
        </Row>
        <FooterText>
          @{process.env.REACT_APP_CONFIG_YEAR} Universidad Abierta para Adultos. Todos los
          derechos reservados.
        </FooterText>
        <SmallHeightDivider />
        {process.env.REACT_APP_CONFIG_SHOW_OGTIC_CERTIFICATES == 1 &&
          <CertificationsContainer>
            <LogosContainer>
              <a target="_blank" href="https://optic.gob.do/nortic/index.php/certificaciones/instituciones-certificadas/item/ministerio-de-turismo-mitur">
                <CertificationsImage src={A3} />
              </a>
              <div style={{ width: '10px' }} />
              <a target="_blank" href="https://optic.gob.do/nortic/index.php/certificaciones/instituciones-certificadas/item/ministerio-de-turismo-mitur">
                <CertificationsImage src={A2} />
              </a>
              <div style={{ width: '10px' }} />
              <a target="_blank" href="https://optic.gob.do/nortic/index.php/certificaciones/instituciones-certificadas/item/ministerio-de-turismo-mitur">
                <CertificationsImage src={E1} />
              </a>
            </LogosContainer>
          </CertificationsContainer>
        }
        <SmallHeightDivider />

      </CenterContainer>
    </FooterContainer>
  );
}

export default Footer;
